import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40"
      data-testid="not-found-page"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-7">
          <p className="label mb-4">404 · Out of frame</p>
          <h1 className="serif text-6xl md:text-8xl tracking-tight font-light leading-[1.02]">
            This page
            <br />
            <span className="italic text-[hsl(var(--ink-soft))]">
              wandered off.
            </span>
          </h1>
          <p className="mt-8 max-w-xl text-[hsl(var(--ink-soft))] text-lg leading-relaxed">
            The link you followed is either retired or never existed. The
            studio's still here — pick a door below.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/"
              className="bg-foreground text-background px-7 py-3.5 text-xs uppercase tracking-[0.18em] hover:opacity-90"
              data-testid="not-found-home"
            >
              Back to home
            </Link>
            <Link
              to="/work"
              className="border border-foreground px-7 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-foreground hover:text-background transition-colors"
              data-testid="not-found-work"
            >
              See the work
            </Link>
            <Link
              to="/contact"
              className="border border-foreground px-7 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-foreground hover:text-background transition-colors"
              data-testid="not-found-contact"
            >
              Contact the studio
            </Link>
          </div>
        </div>

        <div className="md:col-span-5">
          <p className="label mb-4">Where to next</p>
          <ul className="divide-y divide-border border-y border-border">
            {[
              { to: "/about", label: "About the artist" },
              { to: "/commissions", label: "Commission a painting" },
              { to: "/prints", label: "Signed limited-edition prints" },
              { to: "/press", label: "Press & coverage" },
              { to: "/studio-visit", label: "Book a studio visit" },
            ].map((l) => (
              <li key={l.to} className="py-4">
                <Link
                  to={l.to}
                  className="serif text-xl link-underline"
                  data-testid={`not-found-link-${l.to.slice(1) || "home"}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
